// Resizes/compresses Unsplash source images on the fly via their URL API,
// so we never ship multi-MB originals for a 300px card thumbnail.
export function optimizeImg(url, width = 600, quality = 70) {
  if (!url || !url.includes("images.unsplash.com")) return url;

  try {
    const u = new URL(url);
    u.searchParams.set("w", String(width));
    u.searchParams.set("q", String(quality));
    u.searchParams.set("auto", "format");
    u.searchParams.set("fit", "crop");
    return u.toString();
  } catch {
    return url;
  }
}
